import { ProjectPreview } from "./Project"

export class Feature {
  id = ""
  name = ""
  project?: ProjectPreview
  epicsCount = 0
  roadmapPriority: number | null = null
  goalPriority: number | null = null

  constructor(props?: Partial<Feature>) {
    if (!props) return

    Object.keys(props).forEach(field => {
      if (props[field] === undefined) return
      this[field] = props[field]
    })
  }

  static create(feature?: Partial<Feature>): Feature {
    return new Feature(feature)
  }

  get projectId(): string {
    return this.project?.id ?? ""
  }

  static createDefault(): Feature {
    return new Feature()
  }

  getJsonObj() {
    return {
      name: this.name
    }
  }
}
